import React, { useContext, useEffect } from "react";

import { Grid } from "@material-ui/core";
import { Formik, useFormikContext } from "formik";
import { useSelector } from "react-redux";

import { BuyerFields } from "components/QuickEditSaleLotForm/BidderAndBuyerFields";

import { getSaleLotById } from "selectors";

import {
  WeighBridgeSaleDispatchContext,
} from "containers/WeighbridgeSaleView/WeighBridgeSaleContext";

// buyer_way on the API object carries additional fields beyond id/name;
interface FormValues {
  buyerId: string | null;
  buyerWay: { id: number | string; name: string } | null;
  destinationPropertyId: string | null;
}

interface FormSyncEffectProps {
  updateSaleLotSellingDetails: (
    details: Record<string, unknown>,
    setDirty: boolean,
  ) => void;
}

// Syncs Formik buyer fields back to WeighBridgeSaleContext on every change.
function FormSyncEffect({ updateSaleLotSellingDetails }: FormSyncEffectProps) {
  const { values: { buyerId, buyerWay, destinationPropertyId }, dirty } =
    useFormikContext<FormValues>();

  useEffect(() => {
    if (!dirty) return;
    updateSaleLotSellingDetails(
      {
        buyerId,
        buyerWayId: buyerWay?.id,
        buyerWayName: buyerWay?.name,
        propertyId: destinationPropertyId,
      },
      true,
    );
  }, [buyerId, buyerWay?.id, buyerWay?.name, destinationPropertyId, dirty, updateSaleLotSellingDetails]);

  return null;
}

interface WeighbridgeKeyboardSellFormProps {
  saleLotId: string;
}

export function WeighbridgeKeyboardSellForm({
  saleLotId,
}: WeighbridgeKeyboardSellFormProps) {
  const saleLot = useSelector(getSaleLotById(saleLotId));
  const { updateSaleLotSellingDetails } = useContext(
    WeighBridgeSaleDispatchContext,
  );

  if (!saleLot) {
    return null;
  }

  const initialValues: FormValues = {
    buyerId: saleLot.buyer_id ?? null,
    buyerWay: saleLot.buyer_way ?? null,
    destinationPropertyId: saleLot.destination_property_id ?? null,
  };

  return (
    <Formik
      key={saleLotId}
      initialValues={initialValues}
      onSubmit={() => {}}
    >
      <div>
        <Grid container spacing={2}>
          <BuyerFields
            isAutoFocusing={false}
            readOnly={false}
            isUsingRegisteredBidders={false}
            hidePICField
          />
        </Grid>
        <FormSyncEffect
          updateSaleLotSellingDetails={updateSaleLotSellingDetails}
        />
      </div>
    </Formik>
  );
}
